import { LOCAL_STORAGE } from '@/utils/constants';

export const shouldDisplayNewTag = (isLoggedIn: boolean, hasFeatureFlag: boolean, userId: string) => {
    if (!hasFeatureFlag || !isLoggedIn || !userId) {
        return false;
    }

    const hasSeenNewRewardsPage = localStorage.getItem(`${LOCAL_STORAGE.HAS_SEEN_NEW_REWARDS_PAGE}-${userId}`);

    return hasSeenNewRewardsPage === 'false';
};
